/** Accepts a URL string or a content-builder image object (possibly nested). */
export function readKioskHeaderLogoUrl(logo: unknown): string | undefined {
  if (typeof logo === 'string') {
    const trimmed = logo.trim();
    return trimmed || undefined;
  }
  if (!logo || typeof logo !== 'object') {
    return undefined;
  }
  const url = (logo as { url?: unknown }).url;
  if (typeof url === 'string') {
    const trimmed = url.trim();
    return trimmed || undefined;
  }
  if (url && typeof url === 'object') {
    const nested = (url as { url?: unknown }).url;
    if (typeof nested === 'string' && nested.trim()) {
      return nested.trim();
    }
  }
  return undefined;
}
